export default __webpack_public_path__ + "static/media/crown-middle-logo.29ea1d69.png";